<template>
  <div class="page-404">
    <ErrorPage code="404" desc="对不起，您访问的页面不存在！">
      <img slot="img" src="../assets/image/404.jpg" alt="" />
    </ErrorPage>
  </div>
</template>
<script>
import ErrorPage from 'components/error/errorPage';
export default {
  components: {
    ErrorPage
  }
};
</script>
